var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vrm-button-dropdown",attrs:{"id":"dropdownMenu"}},_vm._l((_vm.options),function(option){return _c('div',{key:option.id,staticClass:"vrm-button-dropdown--option",on:{"pointerup":option.action}},[_vm._v("\n        "+_vm._s(option.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }